import CopyWrapper from "components/Common/CopyWrapper";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import {
  COLOR_USER_PLAN_PURCHASE_STATUS,
  ENUM_USER_PLAN_PURCHASE_STATUS,
  LIST_OPTION_GENDER,
  LIST_USER_PLAN_PURCHASE_STATUS,
} from "helpers/constans";
import {
  formatDateStringToKorea,
  formatNumberWithCommas,
} from "helpers/format";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import NO_IMAGE_USER from "../../../assets/images/no-user.png";
import noImageStore from "../../../assets/images/no-job-post.png";
import { toast } from "react-toastify";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { JobSeekerProfileFormat } from "api/types/_user";
import JobPostSection from "./component/JobPostSection";
import ResumeViewSection from "./component/ResumeViewSection";
import ModalConfirm from "components/Common/ModalConfirmDuplicate";
import userPlanPurchaseApi from "api/userPlanPurchaseApi";
import DropdownStatusNew from "components/Common/DropdownStatusNew";

registerLocale("en", en);
registerLocale("ko", ko);

const PlanPurchaseInfoTab = ({ data, handleUpdateSuccess, setLinkImage }: any) => {
  const { t, i18n } = useTranslation();

  const [dataFormat, setDataFormat] = useState<JobSeekerProfileFormat | any>(
    null
  );
  const [lstStatusUserPurchase, setStatusUserPurchase] = useState<any>([]);
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [userPurcharseStatus, setUserPurcharseStatus] = useState<any>("");

  const getUserPurchaseStatus = (status: string) => {
    switch (status) {
      case ENUM_USER_PLAN_PURCHASE_STATUS.ACTIVE:
        setStatusUserPurchase(
          LIST_USER_PLAN_PURCHASE_STATUS?.filter((item: any) =>
            [
              ENUM_USER_PLAN_PURCHASE_STATUS.ACTIVE,
              ENUM_USER_PLAN_PURCHASE_STATUS.REVOKED,
            ]?.includes(item?.value)
          )
        );
        break;
      default:
        setStatusUserPurchase(LIST_USER_PLAN_PURCHASE_STATUS);
        break;
    }
  };

  useEffect(() => {
    if (data) {
      const sectionInfo = data?.banner ? data?.banner : data?.section;
      console.log(sectionInfo)
      getUserPurchaseStatus(data?.status);
      setDataFormat({
        profileUrlUser: data?.user?.imageUrls?.[0] || "",
        status: data?.status,
        gender: data?.user?.profile?.gender,
        fullname: data?.user?.profile?.fullname || "",
        phoneNumber: data?.user?.profile?.phoneNumber || "",
        email:
          data?.user?.profile?.email ||
          (data?.user?.email ?? data?.user?.providerId),
        storeUrl: data?.user?.store?.thumbnailUrl || "",
        storeName: data?.user?.store?.name || "",
        storeAddress: data?.user?.store?.address?.shortAddress || "",
        businessNumber: data?.user?.store?.managerPhoneNumber || "",
        planCode: data?.plan?.code || "",
        planName: data?.plan?.info?.name || "",
        planDescription: data?.plan?.info?.description || "",
        planPrice: data?.plan?.price?.price || "",
        planCurrency: data?.plan?.price?.currency || "",
        discountRate: data?.plan?.price?.discountRate || "",
        priceFinal: data?.plan?.price?.priceFinal || "",
        planVAT: data?.plan?.price?.vatRate || "",
        totalAmount: data?.payment?.totalAmount,
        createdAt: data?.createdAt,
        planType: data?.features || [],
        sectionName: sectionInfo?.fullName,
        sectionPrice: sectionInfo?.price,
        discountSectionRate: sectionInfo?.discountRate,
        sectionFriceFinal: sectionInfo?.priceFinal,
        sectionCurrency: sectionInfo?.currency,
        sectionDescription: sectionInfo?.description,
        jobPost: data?.jobPost,
      });
    }
  }, [JSON.stringify(data)]);

  const handleActionUpdateStatus = async () => {
    if (!data?.id || !userPurcharseStatus) return;

    try {
      const response: any = await userPlanPurchaseApi.putUserPlanPurchase(
        data?.id,
        { status: userPurcharseStatus }
      );

      if (response?.data) {
        handleUpdateSuccess && handleUpdateSuccess();
        onCloseConfirmClick();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setIsOpenConfirm(false);
    setIsConfirmLoading((_prev) => false);
  };

  useEffect(() => {
    document.title = `${t("Account Info")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Row>
        <Col lg={12} className="mt-4 px-4">
          <div>
            <Row>
              <Col lg={5}>
                <div
                  className="mb-4 pt-3 pb-1 px-3 position-relative"
                  style={{
                    border: "1px dashed var(--vz-primary)",
                    borderRadius: "4px",
                  }}
                >
                  <span
                    className="text-primary position-absolute fs-13 px-1"
                    style={{
                      backgroundColor: "var(--vz-secondary-bg)",
                      top: "0px",
                      transform: "translateY(-50%)",
                    }}
                  >
                    {t("User Recruiter")}
                  </span>
                  <div className="d-flex flex-column flex-lg-row gap-2 gap-lg-4">
                    <div className="my-3 d-flex flex-column flex-lg-row gap-4 gap-lg-4">
                      <div>
                        <div
                          className="position-relative"
                          style={{
                            minWidth: "140px",
                            width: "140px",
                            height: "140px",
                            // border: "1px solid var(--vz-input-border-custom)",
                            overflow: "hidden",
                            borderRadius: "var(--vz-border-radius)",
                          }}
                          onClick={() => setLinkImage && setLinkImage({ url: dataFormat?.profileUrlUser || "" })}
                        >
                          <img
                            className="rounded-circle avatar-sm"
                            src={dataFormat?.profileUrlUser || NO_IMAGE_USER}
                            alt={`preview-user`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = NO_IMAGE_USER;
                            }}
                          />
                        </div>
                        <div className="text-center pt-2">
                          {t(
                            LIST_OPTION_GENDER?.find(
                              (item: any) => item?.value === dataFormat?.gender
                            )?.label || "-"
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="mb-3">
                          <Label htmlFor="name" className="form-label">
                            {t("Full Name")}
                          </Label>
                          <div className="cursor-pointer">
                            {dataFormat?.fullname ? (
                              <CopyWrapper contentCopy={dataFormat?.fullname}>
                                {dataFormat?.fullname}
                              </CopyWrapper>
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="name" className="form-label">
                            {t("Phone Number")}
                          </Label>
                          <div className="cursor-pointer">
                            {dataFormat?.phoneNumber ? (
                              <CopyWrapper
                                contentCopy={dataFormat?.phoneNumber}
                              >
                                {dataFormat?.phoneNumber}
                              </CopyWrapper>
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="name" className="form-label">
                            {t("Email")}
                          </Label>
                          <div className="cursor-pointer">
                            {dataFormat?.email ? (
                              <CopyWrapper contentCopy={dataFormat?.email}>
                                {dataFormat?.email}
                              </CopyWrapper>
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col lg={7}>
                <div
                  className="mb-4 pt-3 pb-1 px-3 position-relative"
                  style={{
                    border: "1px dashed var(--vz-primary)",
                    borderRadius: "4px",
                  }}
                >
                  <span
                    className="text-primary position-absolute fs-13 px-1"
                    style={{
                      backgroundColor: "var(--vz-secondary-bg)",
                      top: "0px",
                      transform: "translateY(-50%)",
                    }}
                  >
                    {t("Store Info")}
                  </span>
                  <div className="d-flex flex-column flex-lg-row gap-2 gap-lg-4">
                    <div className="my-3 d-flex flex-column flex-lg-row gap-4 gap-lg-4">
                      <div>
                        <div
                          className="position-relative cursor-pointer"
                          style={{
                            minWidth: "140px",
                            width: "140px",
                            height: "140px",
                            // border: "1px solid var(--vz-input-border-custom)",
                            overflow: "hidden",
                            borderRadius: "var(--vz-border-radius)",
                          }}
                          onClick={() => setLinkImage && setLinkImage({ url: dataFormat?.storeUrl || "" })}
                        >
                          <img
                            className=""
                            src={dataFormat?.storeUrl || noImageStore}
                            alt={`preview-user`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = noImageStore;
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="mb-3">
                          <Label htmlFor="name" className="form-label">
                            {t("Store Name")}
                          </Label>
                          <div className="cursor-pointer">
                            {dataFormat?.storeName ? (
                              <CopyWrapper contentCopy={dataFormat?.storeName}>
                                {dataFormat?.storeName}
                              </CopyWrapper>
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="name" className="form-label">
                            {t("Store Address")}
                          </Label>
                          <div className="cursor-pointer">
                            {dataFormat?.storeAddress ? (
                              <CopyWrapper
                                contentCopy={dataFormat?.storeAddress}
                              >
                                {dataFormat?.storeAddress}
                              </CopyWrapper>
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="name" className="form-label">
                            {t("Business Number")}
                          </Label>
                          <div className="cursor-pointer">
                            {dataFormat?.businessNumber ? (
                              <CopyWrapper
                                contentCopy={dataFormat?.businessNumber}
                              >
                                {dataFormat?.businessNumber}
                              </CopyWrapper>
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            
            <div
              className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative"
              style={{
                border: "1px dashed var(--vz-primary)",
                borderRadius: "4px",
              }}
            >
              <span
                className="text-primary position-absolute fs-13 px-1"
                style={{
                  backgroundColor: "var(--vz-secondary-bg)",
                  top: "0px",
                  transform: "translateY(-50%)",
                }}
              >
                {t("Section Info")}
              </span>

              <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-4">
                <div className="flex-grow-1">
                  <Row>
                    <Col md={3} lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="sectionName" className="form-label">
                          {t("Section Name")}
                        </Label>
                        <div className="cursor-pointer">
                          {dataFormat?.sectionName ? (
                            <CopyWrapper contentCopy={dataFormat?.sectionName}>
                              {dataFormat?.sectionName}
                            </CopyWrapper>
                          ) : (
                            "-"
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col md={3} lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="sectionPrice" className="form-label">
                          {t("Section Price")}{" "}
                        </Label>
                        <div>
                          {formatNumberWithCommas(dataFormat?.sectionPrice) || "-"}{" "}
                          {dataFormat?.sectionCurrency === "KRW" ? "₩" : ""}
                        </div>
                      </div>
                    </Col>

                    <Col md={3} lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="discountSectionRate" className="form-label">
                          {`${t("Discount Section Rate")} (%)`}{" "}
                        </Label>
                        <div>{`${dataFormat?.discountSectionRate ?? 0}%` || "-"}</div>
                      </div>
                    </Col>

                    <Col md={3} lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="Discount" className="form-label">
                          {t("Section Final Price")}
                        </Label>
                        <div>
                          {formatNumberWithCommas(dataFormat?.sectionFriceFinal) || "-"}{" "}
                          {dataFormat?.sectionCurrency === "KRW" ? "₩" : ""}
                        </div>
                      </div>
                    </Col>

                    <Col md={12} lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="sectionDescription" className="form-label">
                          {t("Section Description")}
                        </Label>
                        <div className="cursor-pointer">
                          {dataFormat?.sectionDescription ? (
                            <CopyWrapper contentCopy={dataFormat?.sectionDescription}>
                              {dataFormat?.sectionDescription}
                            </CopyWrapper>
                          ) : (
                            "-"
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            <div
              className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative"
              style={{
                border: "1px dashed var(--vz-primary)",
                borderRadius: "4px",
              }}
            >
              <span
                className="text-primary position-absolute fs-13 px-1"
                style={{
                  backgroundColor: "var(--vz-secondary-bg)",
                  top: "0px",
                  transform: "translateY(-50%)",
                }}
              >
                {t("Plan Info")}
              </span>

              <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-4">
                <div className="flex-grow-1">
                  <Row>
                    <Col md={4} lg={4}>
                      <div className="mb-3">
                        <Label htmlFor="planCode" className="form-label">
                          {t("Plan Code")}
                        </Label>
                        <div className="cursor-pointer">
                          {dataFormat?.planCode ? (
                            <CopyWrapper contentCopy={dataFormat?.planCode}>
                              {dataFormat?.planCode}
                            </CopyWrapper>
                          ) : (
                            "-"
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col md={4} lg={4}>
                      <div className="mb-3">
                        <Label htmlFor="signup_date" className="form-label">
                          {t("Created at")}
                        </Label>
                        <div>
                          {dataFormat?.createdAt
                            ? formatDateStringToKorea(dataFormat?.createdAt)
                            : "-"}
                        </div>
                      </div>
                    </Col>

                    <Col md={4} lg={4}>
                      <div className="mb-3">
                        <Label htmlFor="gender" className="form-label">
                          {t("Status")} <span className="text-danger">*</span>
                        </Label>
                        {
                          dataFormat?.status === ENUM_USER_PLAN_PURCHASE_STATUS.ACTIVE ? (
                            <DropdownStatusNew
                              name="gender"
                              dataList={lstStatusUserPurchase}
                              placeholder={`${t("Status")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={dataFormat?.status}
                              onChangeSelect={(e: any) => {
                                if (e?.value !== dataFormat?.status) {
                                  setUserPurcharseStatus(e?.value);
                                  setIsOpenConfirm(true);
                                }
                              }}
                              isHasOptionAll={false}
                              disabled={
                                dataFormat?.status ===
                                ENUM_USER_PLAN_PURCHASE_STATUS.ACTIVE
                                  ? false
                                  : true
                              }
                              colors={COLOR_USER_PLAN_PURCHASE_STATUS}
                            />
                          ): (
                            <div>
                              <span
                                className={`rounded-pill badge bg-${
                                  COLOR_USER_PLAN_PURCHASE_STATUS[data?.status] || "secondary"
                                }`}
                                style={{
                                  fontSize: "0.8rem",
                                  lineHeight: 1
                                }}
                              >
                                {t(
                                  LIST_USER_PLAN_PURCHASE_STATUS?.find(
                                    (item: any) => (item?.value) == (data?.status)
                                  )?.label || ""
                                )}
                              </span>
                            </div>
                          )
                        }
                      </div>
                    </Col>

                    <Col md={12} lg={12}>
                      <div className="mb-3 mt-2">
                        <Label htmlFor="website" className="form-label">
                          {t("Plan Name")}
                        </Label>
                        <div className="cursor-pointer">
                          <CopyWrapper contentCopy={dataFormat?.planName}>
                            {dataFormat?.planName || "-"}
                          </CopyWrapper>
                        </div>
                      </div>
                    </Col>

                    <Col md={12} lg={12}>
                      <div className="mb-3 mt-2">
                        <Label htmlFor="website" className="form-label">
                          {t("Plan Description")}
                        </Label>
                        <div className="cursor-pointer">
                          <CopyWrapper
                            contentCopy={dataFormat?.planDescription}
                          >
                            {dataFormat?.planDescription || "-"}
                          </CopyWrapper>
                        </div>
                      </div>
                    </Col>

                    <Col md={2} lg={2}>
                      <div className="mb-3 mt-2">
                        <Label htmlFor="website" className="form-label">
                          {t("Plan Price")}{" "}
                        </Label>
                        <div>
                          {formatNumberWithCommas(dataFormat?.planPrice) || "-"}{" "}
                          {dataFormat?.planCurrency === "KRW" ? "₩" : ""}
                        </div>
                      </div>
                    </Col>

                    <Col md={2} lg={2}>
                      <div className="mb-3 mt-2">
                        <Label htmlFor="discountRate" className="form-label">
                          {`${t("Discount Rate")} (%)`}{" "}
                        </Label>
                        <div>{`${dataFormat?.discountRate ?? 0}%` || "-"}</div>
                      </div>
                    </Col>

                    <Col md={2} lg={2}>
                      <div className="mb-3 mt-2">
                        <Label htmlFor="Discount" className="form-label">
                          {t("Final Price")}
                        </Label>
                        <div>
                          {formatNumberWithCommas(dataFormat?.priceFinal) || "-"}{" "}
                          {dataFormat?.planCurrency === "KRW" ? "₩" : ""}
                        </div>
                      </div>
                    </Col>

                    <Col md={2} lg={2}>
                      <div className="mb-3 mt-2">
                        <Label htmlFor="address" className="form-label">
                          {t("VAT (%)")}
                        </Label>
                        <div>{`${dataFormat?.planVAT}%` || "-"}</div>
                      </div>
                    </Col>

                    <Col md={3} lg={3}>
                      <div className="mb-3 mt-2">
                        <Label htmlFor="address" className="form-label">
                          {t("Total Amount")}
                        </Label>
                        <div>
                          {formatNumberWithCommas(dataFormat?.totalAmount) ||
                            "-"}{" "}
                          {dataFormat?.planCurrency === "KRW" ? "₩" : ""}
                        </div>
                      </div>
                    </Col>

                    <Col md={12} lg={12}>
                      <div className="mb-3 mt-2">
                        <Label htmlFor="address" className="form-label mb-3">
                          {t("Plan Type")}
                        </Label>
                        <div>
                          {dataFormat?.planType?.map(
                            (item: any, index: number) => {
                              if (item?.featureKey === "POST_JOB") {
                                return (
                                  <JobPostSection
                                    item={item}
                                    key={index}
                                    handleUpdateSuccess={handleUpdateSuccess}
                                    setLinkImage={setLinkImage}
                                    jobPostInfo={dataFormat?.jobPost}
                                  />
                                );
                              }

                              return (
                                <ResumeViewSection item={item} key={index} />
                              );
                            }
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>

              <Row className="mt-3"></Row>
            </div>
            <div></div>
          </div>
        </Col>
      </Row>

      <ModalConfirm
        header={t("Are you sure you want to update the status?")}
        title={t(" ")}
        content={t(
          "After confirming this action, the data will be updated. Do you want to proceed?"
        )}
        isOpen={isOpenConfirm}
        isLoading={isConfirmLoading}
        onClose={onCloseConfirmClick}
        onConfirm={handleActionUpdateStatus}
        isShowButtonClose={false}
        textButtonConfirm={"Update"}
      />
    </React.Fragment>
  );
};

export default PlanPurchaseInfoTab;
